import React from "react";
import { motion } from "framer-motion";

const PageHero = ({ label, title, sub, image }) => {
  return (
    <section className="relative pt-36 pb-20 md:pt-44 md:pb-28 overflow-hidden grain">
      <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${image})` }} />
      <div className="absolute inset-0 hero-overlay" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl"
        >
          {label && <div className="section-label mb-4">{label}</div>}
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter leading-none text-white">
            {title}
          </h1>
          {sub && <p className="mt-6 text-base md:text-lg text-[#AAB6C6] leading-relaxed max-w-2xl">{sub}</p>}
        </motion.div>
      </div>
    </section>
  );
};

export default PageHero;
